<template>
  <div class="error">
    <h1>Error</h1>
  </div>
</template>

<script>

export default {
  name: 'Error',
  mixins: [],
  components: {},
  props: {},
  data () {
    return {
      aaaa: '12312321'
    }
  },
  computed: {},
  watch: {},
  created () {},
  mounted () {},
  destroyed () {},
  methods: {},
}
</script>

<style scoped lang="scss">

</style>